module.exports = "https://static.wmbcdn.com/uniweb/images/07cc904e25e765d1f9a9651c82f3c325.svg";